import * as React from 'react';
import NavBar from './NavBar';
import Footer from './Footer';

const Layout = ({showLogo = false, children, footer = true}) => (
    <>
        <NavBar showLogo={showLogo} />
        {children}
        {footer && <Footer />}
    </>
);

export default Layout;
